import Vue from "vue"

const isTrack = (el, binding) => {
    const { value, name } = binding
    if (!value) return
    if (name && name === "track") {
        el.addEventListener("click", function () {
            Vue.prototype.$trackEvent(value[0], value[1], value[0])
            // this.$trackEvent(tab.name, '点击文字', tab.name)
        })
        el.addEventListener("mouseenter", function () {
            Vue.prototype.$trackEvent(value[0], value[1], value[0])
        })
    }
}

export default (Vue, name = "track") => {
    Vue.directive(name, {
        bind: isTrack,
        componentUpdated: isTrack
    })
}